import { Star } from '@phosphor-icons/react';

interface StarRatingProps {
  /** 0–5; supports halves via rounding for the fill count. */
  rating: number;
  /** When set, renders a single star + numeric value (compact card style). */
  compact?: boolean | undefined;
  reviewCount?: number | undefined;
  className?: string | undefined;
}

/**
 * Warm Editorial star rating. Rating glyphs are clay (brand.blue → clay in the
 * v2 palette), with unfilled stars in a soft clay tint.
 */
export function StarRating({ rating, compact, reviewCount, className }: StarRatingProps) {
  if (compact) {
    return (
      <span
        className={`inline-flex items-center gap-1 text-sm font-semibold text-ink ${className ?? ''}`}
      >
        <Star weight="fill" className="h-4 w-4 text-clay" aria-hidden="true" />
        {rating.toFixed(1)}
        <span className="sr-only">out of 5</span>
      </span>
    );
  }

  const full = Math.round(rating);
  return (
    <span
      className={`inline-flex items-center gap-1 ${className ?? ''}`}
      role="img"
      aria-label={`Rated ${rating.toFixed(1)} out of 5${
        reviewCount != null ? ` from ${reviewCount} reviews` : ''
      }`}
    >
      {Array.from({ length: 5 }).map((_, i) => (
        <Star
          key={i}
          weight={i < full ? 'fill' : 'light'}
          className={i < full ? 'h-4 w-4 text-clay' : 'h-4 w-4 text-primary-200'}
          aria-hidden="true"
        />
      ))}
      {reviewCount != null && (
        <span className="ml-1 text-sm text-ink-muted">({reviewCount})</span>
      )}
    </span>
  );
}
